import * as React from "react";
import Layout from "../components/xathlo/Layout";
import { HomeLink } from "../components/xathlo/HomeLink";
import { homePageRoute } from "../routes/xathlo";
import { AccountBtn } from "../components/user/AccountBtn";
import { UserSpaceSwitch } from "../components/user/UserSpaceSwitch";
import { dashboardRoute, login, redirectToCodec } from "../routes/user";
import { useUser } from "../utils/supabase/useUser";
import { useSupabase } from "../utils/supabase/useSupabase";
import { option } from "fp-ts";
import { constNull, pipe } from "fp-ts/function";
import { Breadcrumbs, Container } from "@mui/material";
import { MyOrganizationsList } from "../components/user/MyOrganizationsList";
import { MyResultsList } from "../components/user/MyResultsList";
import { rightOrThrow } from "../utils/fp";
import { useRouter } from "next/router";

export default () => {
    const userO = useUser();
    const isAuthed = option.isSome(userO);
    const supabase = useSupabase();
    const router = useRouter();

    React.useEffect(() => {
        // the user context is filled in its provider's effect, which runs after
        // this one, so the session is read from the client directly
        if (!isAuthed && supabase.auth.session() == null) {
            router.replace(
                login.route({
                    redirectTo: pipe(
                        dashboardRoute.route({}).pathname,
                        redirectToCodec.decode,
                        rightOrThrow
                    ),
                })
            );
        }
    }, [isAuthed, supabase, router]);

    return (
        <Layout
            breadCrumbs={
                <Breadcrumbs>
                    <HomeLink href={homePageRoute.route({})} variant={"x"} />
                    {pipe(
                        userO,
                        option.fold(constNull, (user) => (
                            <UserSpaceSwitch
                                route={dashboardRoute.route({})}
                                label={user.email || ""}
                            />
                        ))
                    )}
                </Breadcrumbs>
            }
            rightMenu={<AccountBtn />}
        >
            <Container maxWidth={"md"}>
                {/*my registrations*/}
                <MyOrganizationsList />
                {/*next races where I am editor*/}
                <MyResultsList />
            </Container>
        </Layout>
    );
};
